import React from "react";
import { loginWithAzureADToken } from "actions/authentication";
import { useDispatch } from "react-redux";
import { InlineWaiting } from "components/ui";
import { PublicClientApplication } from "@azure/msal-browser";
import { AZURE_CLIENT_ID, AZURE_TENANT_ID } from "environment";
import Button from "components/ui_new/button";

export const getAzureClientIdFromUrl = () => {
  if (
    window.location.href
      .toLowerCase()
      .includes("atlantichome.sleepsolutionsandservices.com")
  ) {
    return "86bcdb64-496f-4b7a-9f87-b1a7d1fdcf19";
  }
  if (AZURE_CLIENT_ID) return AZURE_CLIENT_ID;
  return "";
};

// These two values must match the API's server-side allow-lists or login is rejected
// (S3DEV2-7644): the tenant id in AzureSsoAllowedTenantIds, and whichever client id
// getAzureClientIdFromUrl returns in AzureSsoAllowedAudiences. The API validates the Entra
// token's signature, issuer, audience and expiry before issuing a session, so adding a new
// app registration here also needs the corresponding Web.config entry on the API side.
const tenantId = AZURE_TENANT_ID;

export const msalConfig = {
  auth: {
    clientId: getAzureClientIdFromUrl(),
    redirectUri: window.location.origin,
    authority: `https://login.microsoftonline.com/${tenantId}`
    // authority: "https://login.microsoftonline.com/common",
  }
};

const msalInstance = msalConfig.auth.clientId
  ? new PublicClientApplication(msalConfig)
  : null;

const AzureADLogin = () => {
  const dispatch = useDispatch();
  const [isFetching, setIsFetching] = React.useState(false);
  if (!msalInstance) return null;
  return (
    <div style={{ textAlign: "center" }}>
      {isFetching ? (
        <InlineWaiting />
      ) : (
        <Button
          onClick={async () => {
            try {
              setIsFetching(true);
              const loginResponse = await msalInstance.loginPopup();
              await dispatch(
                loginWithAzureADToken({
                  idToken: loginResponse.idToken,
                  tenantId: loginResponse.tenantId,
                  email: loginResponse.account.username
                })
              );
            } catch (e) {
              console.error(e);
            } finally {
              setIsFetching(false);
            }
          }}
        >
          Login with Office365
        </Button>
      )}
    </div>
  );
};

export default AzureADLogin;
